// https://vuex.vuejs.org/en/actions.html
import axios from "axios";

export default {
    AUTH_REQUEST({ commit, dispatch }, user) {
        return new Promise((resolve, reject) => {
            commit("AUTH_REQUEST");

            const baseUrl = window.location.origin.startsWith(
                "http://localhost:8080"
            )
                ? "https://localhost:44388"
                : window.location.origin;

            const url = baseUrl + "/api/login/portalLogin?";

            axios
                .post(url, {
                    username: user.username,
                    password: user.password,
                })
                .then((resp) => {
                    const response = resp.data;

                    const token = new Date();

                    localStorage.setItem("user-token", token);
                    localStorage.setItem("user-name", user.username);
                    localStorage.setItem("user-role", response.role);

                    commit("AUTH_SUCCESS", {
                        token: token,
                        user: user.username,
                        role: response.role,
                    });

                    resolve(response);
                })
                .catch((err) => {
                    commit("AUTH_ERROR", err);

                    localStorage.removeItem("user-token");

                    let errorMessage = err;

                    if (err.response.data && err.response.data.Message) {
                        errorMessage = err.response.data.Message;
                    }

                    reject(errorMessage);
                });
        });
    },
    AUTH_LOGOUT({ commit, dispatch }) {
        localStorage.removeItem("user-token");

        commit("AUTH_LOGOUT");
    },
};
